import React from 'react';
import './Preloader.css'; // Импортируйте стили для анимации

const Preloader = () => {
    return (
        <div className="preloader">
            <div className="loader"></div>
        </div>
    );
};

export default Preloader;